import React, { memo, useMemo } from 'react';
import { getContext, Symbols } from 'choerodon-ui/shared';
import { getPrefixCls } from '../configure/utils';
const AnchorContext = getContext(Symbols.AnchorContext, { getPrefixCls });
const BaseAnchorContextProvider = function AnchorContextProvider(props) {
    const { children, c7nAnchor, getPrefixCls: getGlobalPrefixCls } = props;
    const value = useMemo(() => ({
        c7nAnchor,
        getPrefixCls: getGlobalPrefixCls,
    }), [getGlobalPrefixCls, c7nAnchor]);
    return (React.createElement(AnchorContext.Provider, { value: value }, children));
};
BaseAnchorContextProvider.displayName = 'AnchorContextProvider';
export const AnchorContextProvider = memo(BaseAnchorContextProvider);
export default AnchorContext;
